<template>
    <a-form :form="smartConfigForm" v-show="smartConfigStatus == 'process'">
        <a-form-item :label="$t('supervise.timeingName')" :label-col="{ xl:{span: 4},lg: { span: 24  } }" :wrapper-col="{ xl:{span: 20},lg: { span: 24  } }">
            <a-switch size="small" v-model="rollCallSetting"></a-switch>
        </a-form-item>

        <a-row :gutter="24" v-if="rollCallSetting">
            <a-col :span="1"></a-col>
            <a-col :span="22" style="border-left:1px solid #e9eaec;border-right:1px solid #e9eaec;border-bottom:1px solid #e9eaec;">
                <a-divider orientation="left" style="position:absolute;font-size:12px;margin-top:-9px;margin-left:-12px">{{$t('supervise.timeingName')}}</a-divider>
                <a-row style="margin-top:15px"/>
                <a-row :gutter="24" v-for="(item,index) in rollCall" :key="index">
                    <a-col :xs="{span:18}" :sm="{span:24}">
                        <a-form-item :validateStatus="item.timeValidateStatus" :help="item.timeErrorMessage" :label="$t('supervise.time') + (index + 1)"  v-bind="formItemLayout">
                            <a-row>
                                <a-col span="18">
                                    <a-time-picker @change="onTimeChange" size="small"  style="width:98%" format="HH:mm:ss" v-model="item.time" :placeholder="$t('supervise.selecteTimeTip')"></a-time-picker>
                                </a-col>
                                <a-col span="6" v-if="index == 0 && rollCall.length < 5">
                                    <a-button size="small"  icon="plus"  @click="addRollCall()"></a-button>
                                </a-col>
                                <a-col span="6" v-if="index != 0">
                                    <a-button size="small"  icon="delete" @click="deleteRollCall(index)"></a-button>
                                </a-col>
                            </a-row>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="1"></a-col>
        </a-row>

        <a-form-item :label="$t('supervise.timeingHeart')"  :label-col="{ xl:{span: 4},lg: { span: 24  } }" :wrapper-col="{ xl:{span: 20},lg: { span: 24  } }">
            <a-switch size="small" v-model="heartSetting"></a-switch>
        </a-form-item>

        <a-row :gutter="24" v-if="heartSetting">
            <a-col :span="1"></a-col>
            <a-col :span="22" style="border-left:1px solid #e9eaec;border-right:1px solid #e9eaec;border-bottom:1px solid #e9eaec;">
                <a-divider orientation="left" style="position:absolute;font-size:12px;margin-top:-9px;margin-left:-12px">{{$t('supervise.timeingHeart')}}</a-divider>
                <a-row style="margin-top:15px"/>
                <a-row :gutter="24" v-for="(item,index) in heartClock" :key="index">
                    <a-col :xs="{span:18}" :sm="{span:24}">
                        <a-form-item :validateStatus="item.timeValidateStatus" :help="item.timeErrorMessage" :label="$t('supervise.time') + (index + 1)"   v-bind="formItemLayout">
                            <a-row>
                                <a-col span="18">
                                    <a-time-picker @change="onTimeChange" size="small"  style="width:98%" format="HH:mm:ss" v-model="item.time" :placeholder="$t('supervise.selecteTimeTip')"></a-time-picker>
                                </a-col>
                                <a-col span="6" v-if="index == 0 && heartClock.length < 5">
                                    <a-button size="small" icon="plus"  @click="addHeartClock()"></a-button>
                                </a-col>
                                <a-col span="6" v-if="index != 0">
                                    <a-button size="small" icon="delete" @click="deleteHeartClock(index)"></a-button>
                                </a-col>
                            </a-row>
                        </a-form-item>
                    </a-col>

                </a-row>
            </a-col>
            <a-col :span="1"></a-col>
        </a-row>

        <a-form-item :wrapper-col="{ span: 12, offset: 3 }" style="margin-top:10px">
            <a-button style="margin-left:10px" @click="gotoPrevious">{{$t('global.pre')}}</a-button>
            <a-button style="margin-left:10px" type="primary" @click="gotoNext">{{$t('global.next')}}</a-button>
        </a-form-item>
    </a-form>

</template>

<script>
    import moment from 'moment'

    export default {
        name: 'ZAddSmartcConfig',
        props:['smartConfigStatus'],
        data() {
            return {
                smartConfigForm:null,
                rollCallSetting:false,
                heartSetting:false,
                rollCall: [{
                    "time":null,
                    "timeValidateStatus":"success",
                    "timeErrorMessage":null
                }],
                heartClock: [{
                    "time":null,
                    "timeValidateStatus":"success",
                    "timeErrorMessage":null
                }],
                formItemLayout: {
                    labelCol: {
                        xs: { span: 20 },
                        sm: { span: 3 },
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 14 },
                    }
                }
            }
        },
        methods:{
            init(){
                this.rollCallSetting = false
                this.heartSetting = false
                this.smartConfigForm = this.$form.createForm(this)
                this.rollCall =[{
                    "time":null,
                    "timeValidateStatus":"success",
                    "timeErrorMessage":null
                }]
                this.heartClock = [{
                    "time":null,
                    "timeValidateStatus":"success",
                    "timeErrorMessage":null
                }]
            },
            onTimeChange(selectTime){
                if(selectTime){
                    selectTime = moment(selectTime.startOf('minute').valueOf())
                }
            },
            addRollCall() {
                this.rollCall.push({
                    "time":null,
                    "timeValidateStatus":"success",
                    "timeErrorMessage":null
                })
            },
            deleteRollCall(index) {
                this.rollCall.splice(index, 1);
            },
            addHeartClock() {
                this.heartClock.push({
                    "time":null,
                    "timeValidateStatus":"success",
                    "timeErrorMessage":null
                })
            },
            deleteHeartClock(index) {
                this.heartClock.splice(index, 1);
            },
            gotoPrevious(){
                this.$emit('gotoPrevious')
            },
            gotoNext(){
                let smartConfigParam = {}
                if(this.rollCallSetting){
                    let rollCalls = []
                    let validFlag = true
                    this.rollCall.map(function(item){
                        if(!item.time){
                            validFlag = false
                            item.timeValidateStatus = 'error'
                            item.timeErrorMessage = '请设置时间'
                            setTimeout(function(){
                                item.timeValidateStatus = "success"
                                item.timeErrorMessage = null
                            },5000)
                            return
                        }
                        rollCalls.push(item.time.hour() * 3600 + item.time.minute() * 60)
                    })
                    if(!validFlag){
                        return
                    }
                    smartConfigParam.rollCalls = rollCalls
                }
                if(this.heartSetting){
                    let heartClocks = []
                    let validFlag = true
                    this.heartClock.map(function(item){
                        if(!item.time){
                            validFlag = false
                            item.timeValidateStatus = 'error'
                            item.timeErrorMessage = '请设置时间'
                            setTimeout(function(){
                                item.timeValidateStatus = "success"
                                item.timeErrorMessage = null
                            },5000)
                            return
                        }
                        heartClocks.push(item.time.hour() * 3600 + item.time.minute() * 60)
                    })
                    if(!validFlag){
                        return
                    }
                    smartConfigParam.heartClocks = heartClocks
                }
                this.$emit('gotoNext',smartConfigParam)
            }
        }
    }
</script>